import React         from 'react';
import ReactDom      from 'react-dom';
import Moment        from 'moment';

import Const         from 'fw_const';
import Utils         from 'utils';

import DraftContentsLogs       from './draft-contents-logs';
import DraftContentsHistory    from './draft-contents-history';
import DraftDetailPreviewModal from './draft-detail-preview-modal';
import VideoInstructionModal from './video-instruction-modal';
// -------------------------------------------------------

class DraftContentsEdit extends React.Component {
  constructor(props) {
    super(props);
    this.init(props);
  }

  init(props) {
    this.state = {
      data : this.props.data,
      tab  : 'search',
      modal : false,
      videoModal: false,
    };
  }

  editInit() {
    let contents = this.props.contents;
    let edit     = this.props.edit;
    let table    = this.props.table;

    if( edit[table] == undefined ) edit[table] = {};
    if( edit[table][contents.id] == undefined ) edit[table][contents.id] = {};

    try { edit[table][contents.id].revise_movie_option = this.props.contents.revise_movie_option } catch(e) {}

    return edit;
  }

  select(now, flg) {
    if( this.props.detail.is_submission == 0 && this.props.detail.my_authority == 99 ){
      alert('管理者権限の下書き編集の【「内容OK」できる状態にする】を選択することで、下書きの確認作業が可能となります。\n※下書き提出の状態になりますので、インフルエンサーにご確認の上作業を行ってください。');
    }
    if( this.props.detail.complete == 1 ) return;

    if( now == 0 && flg == null ){
      let chk = confirm('「修正依頼」の状態を変更してもよろしいですか？\n※変更後は、「内容OK」もしくは「修正依頼」のどちらかを選択してください');
      if( chk == false ) return;
    }
    if( now == 1 && flg == null ){
      let chk = confirm('「内容OK」の状態を変更してもよろしいですか？\n※変更後は、「内容OK」もしくは「修正依頼」のどちらかを選択してください');
      if( chk == false ) return;
    }

    let edit = this.editInit.bind(this)();
    edit[this.props.table][this.props.contents.id].is_approval = flg;

    this.props.update_ev.bind(this)(edit);
  }

  changeCaption() {
    let edit = this.editInit.bind(this)();
    edit[this.props.table][this.props.contents.id].is_approval = 0;
    edit[this.props.table][this.props.contents.id].revise_message = this.revise_message.value;
    this.props.update_ev.bind(this)(edit);
  }

  changeModalCaption(revise_message) {
    try {
      this.revise_message.value = revise_message;
      this.changeCaption.bind(this)();
    } catch(e) {}
  }

  changeModalCaptionMovie(revise_message, revise_movie_option) {
    try {
      //if( revise_message != null ) this.revise_message.value = revise_message;

      let edit = this.editInit.bind(this)();
      edit[this.props.table][this.props.contents.id].is_approval = 0;
      //if( revise_message != null ) edit[this.props.table][this.props.contents.id].revise_message = this.revise_message.value;
      edit[this.props.table][this.props.contents.id].revise_message = this.revise_message.value;
      edit[this.props.table][this.props.contents.id].revise_movie_option = revise_movie_option;

      this.props.update_ev.bind(this)(edit);

    } catch(e) {}
  }

  toggleModal(flg) {
    this.setState({ modal: flg });
    if( flg == false ) Utils.unlockFixedContents();
  }

  render() {
    let contents = this.props.contents;
    let detail   = this.props.detail;
    let edit     = this.props.edit;
    let table    = this.props.table;

    // 編集データの適用
    try { contents = Object.assign(contents, edit[table][contents.id]); } catch(e) {}

    let menus = [
      { id: 1, design: 'ok', name: '内容OK' },
      { id: 0, design: 'ng', name: '修正依頼' },
    ];

    let show_textarea = (contents.is_approval == 0) ? 'show' : 'hide';
    let is_active = (detail.complete == 1) ? 'deactive' : '';

    let edit_id = null;
    try {
      if(table == 'draft_caption'){
        edit_id = ('caption_'+ this.props.contents.contents_id);
      } else {
        edit_id = ('media_'+ this.props.contents.contents_id +'_'+ this.props.contents.id);
      }
    } catch(e) {}

    let is_movie = false;
    try { is_movie = (Utils.isVideo(contents.media_url)); } catch(e) {}

    // 動画指示コメントの取得とフィルタリング（空・空白のみを除外）
    let movieComments = [];
    let movieCommentCount = 0;
    try {
      const parsed = JSON.parse(contents.revise_movie_option);
      if (parsed && Array.isArray(parsed.comments)) {
        movieComments = parsed.comments.filter(comment => comment.content && comment.content.trim() !== '');
        movieCommentCount = movieComments.length;
      }
    } catch(e) {}

    return (
      <div className="draft-edit">
        <div className="detail-modal-button" onClick={this.toggleModal.bind(this, true)}>詳細表示</div>

        <div className="draft-edit-multi">
          { menus.map((d, key) => {
            let flg = (d.id == contents.is_approval) ? 'on': 'off';
            if( contents.is_approval == null ) flg = '';
            let val = (d.id == contents.is_approval) ? null : d.id;
            return <div key={key} className={'button '+ d.design +' '+ flg +' '+ is_active} onClick={this.select.bind(this, contents.is_approval, val)}>{d.name}</div>
          })}
        </div>
        { ( contents.is_approval == null ) && <p className="draft-button-support">どちらかを選択してください</p> }

        { (contents.is_approval == 0 && detail.complete == 0 && is_movie == true)
          ? <div className="draft-edit-caption">
              {/* 動画から直接指示ボタン（件数表示付き） */}
              <button
                type="button"
                onClick={() => this.setState({ videoModal: true })}
                style={{
                  display: 'inline-flex',
                  alignItems: 'center',
                  gap: '5px',
                  padding: '5px 10px',
                  fontSize: '11px',
                  backgroundColor: movieCommentCount > 0 ? '#e8f5e9' : '#e3f2fd',
                  color: movieCommentCount > 0 ? '#1b5e20' : '#0d47a1',
                  border: movieCommentCount > 0 ? '1px solid #a5d6a7' : '1px solid #bbdefb',
                  borderRadius: '4px',
                  cursor: 'pointer',
                  marginBottom: '8px',
                  fontWeight: 'bold',
                }}
              >
                <i className="material-icons" style={{ fontSize: '13px' }}>movie</i>
                { movieCommentCount > 0
                  ? `動画から直接指示（${movieCommentCount}件の指示があります）`
                  : '動画から直接指示'
                }
              </button>
              <textarea className={'text '+ show_textarea} id={edit_id} ref={(input) => { this.revise_message = input }} onChange={this.changeCaption.bind(this)} placeholder="修正指示を入力してください" defaultValue={contents.revise_message} />
              
              {/* 動画直接指示コメント一覧 */}
              {movieComments.length > 0 && (
                <div style={{ marginTop: '12px', border: '1px solid #e0e0e0', borderRadius: '6px', backgroundColor: '#f9f9f9', padding: '12px', textAlign: 'left' }}>
                  <div style={{ fontSize: '11px', fontWeight: 'bold', color: '#666', marginBottom: '10px', borderBottom: '1px solid #e0e0e0', paddingBottom: '4px' }}>動画からの修正指示一覧</div>
                  {movieComments.map((comment, index) => (
                    <div key={comment.id || index} style={{ marginBottom: index === movieComments.length - 1 ? 0 : '12px', paddingBottom: index === movieComments.length - 1 ? 0 : '12px', borderBottom: index === movieComments.length - 1 ? 'none' : '1px dashed #e0e0e0' }}>
                      
                      {/* 番号 & タイムコード */}
                      <div style={{ display: 'flex', alignItems: 'center', gap: '8px', marginBottom: '6px' }}>
                        <span style={{ display: 'inline-flex', alignItems: 'center', justifyContent: 'center', backgroundColor: comment.badgeColor || '#ff4081', color: '#fff', fontSize: '11px', fontWeight: 'bold', width: '18px', height: '18px', borderRadius: '3px' }}>
                          {index + 1}
                        </span>
                        <span style={{ display: 'inline-flex', alignItems: 'center', gap: '3px', color: '#1a73e8', fontSize: '12px', fontWeight: 'bold' }}>
                          <i className="material-icons" style={{ fontSize: '14px', verticalAlign: 'middle' }}>access_time</i>
                          {comment.timecode}
                        </span>
                      </div>
                      
                      {/* アバター & ユーザー名 & 日付 */}
                      <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', gap: '8px', marginBottom: '6px' }}>
                        <div style={{ display: 'flex', alignItems: 'center', gap: '6px' }}>
                          {comment.avatar ? (
                            <img src={comment.avatar} alt={comment.author} style={{ width: '24px', height: '24px', borderRadius: '50%', objectFit: 'cover' }} />
                          ) : (
                            <div style={{ width: '24px', height: '24px', borderRadius: '50%', backgroundColor: '#ccc' }} />
                          )}
                          <span style={{ fontSize: '12px', fontWeight: 'bold', color: '#333' }}>{comment.author}</span>
                        </div>
                        <span style={{ fontSize: '11px', color: '#888' }}>{comment.date}</span>
                      </div>
                      
                      {/* コメント本文 */}
                      <div style={{ fontSize: '12px', color: '#333', paddingLeft: '2px', whiteSpace: 'pre-wrap', wordBreak: 'break-all' }}>
                        {comment.content}
                      </div>

                    </div>
                  ))}
                </div>
              )}
            </div>
          : <div className="draft-edit-caption">
              { (detail.complete == 1)
                ? <textarea className={'text '+ show_textarea} defaultValue={contents.revise_message} disabled={true} />
                : <textarea className={'text '+ show_textarea} id={edit_id} ref={(input) => { this.revise_message = input }} onChange={this.changeCaption.bind(this)} placeholder="修正指示を入力してください" defaultValue={contents.revise_message} />
              }
              
              {/* 動画直接指示コメント一覧 */}
              {movieComments.length > 0 && (
                <div style={{ marginTop: '12px', border: '1px solid #e0e0e0', borderRadius: '6px', backgroundColor: '#f9f9f9', padding: '12px', textAlign: 'left' }}>
                  <div style={{ fontSize: '11px', fontWeight: 'bold', color: '#666', marginBottom: '10px', borderBottom: '1px solid #e0e0e0', paddingBottom: '4px' }}>動画からの修正指示一覧</div>
                  {movieComments.map((comment, index) => (
                    <div key={comment.id || index} style={{ marginBottom: index === movieComments.length - 1 ? 0 : '12px', paddingBottom: index === movieComments.length - 1 ? 0 : '12px', borderBottom: index === movieComments.length - 1 ? 'none' : '1px dashed #e0e0e0' }}>
                      
                      {/* 番号 & タイムコード */}
                      <div style={{ display: 'flex', alignItems: 'center', gap: '8px', marginBottom: '6px' }}>
                        <span style={{ display: 'inline-flex', alignItems: 'center', justifyContent: 'center', backgroundColor: comment.badgeColor || '#ff4081', color: '#fff', fontSize: '11px', fontWeight: 'bold', width: '18px', height: '18px', borderRadius: '3px' }}>
                          {index + 1}
                        </span>
                        <span style={{ display: 'inline-flex', alignItems: 'center', gap: '3px', color: '#1a73e8', fontSize: '12px', fontWeight: 'bold' }}>
                          <i className="material-icons" style={{ fontSize: '14px', verticalAlign: 'middle' }}>access_time</i>
                          {comment.timecode}
                        </span>
                      </div>
                      
                      {/* アバター & ユーザー名 & 日付 */}
                      <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', gap: '8px', marginBottom: '6px' }}>
                        <div style={{ display: 'flex', alignItems: 'center', gap: '6px' }}>
                          {comment.avatar ? (
                            <img src={comment.avatar} alt={comment.author} style={{ width: '24px', height: '24px', borderRadius: '50%', objectFit: 'cover' }} />
                          ) : (
                            <div style={{ width: '24px', height: '24px', borderRadius: '50%', backgroundColor: '#ccc' }} />
                          )}
                          <span style={{ fontSize: '12px', fontWeight: 'bold', color: '#333' }}>{comment.author}</span>
                        </div>
                        <span style={{ fontSize: '11px', color: '#888' }}>{comment.date}</span>
                      </div>
                      
                      {/* コメント本文 */}
                      <div style={{ fontSize: '12px', color: '#333', paddingLeft: '2px', whiteSpace: 'pre-wrap', wordBreak: 'break-all' }}>
                        {comment.content}
                      </div>

                    </div>
                  ))}
                </div>
              )}
            </div>
        }

        { (contents.is_approval == null) && <div className="button-help"><i className="material-icons">info</i>確認後、「内容OK」もしくは「修正依頼」を選択してください</div> }

        <DraftContentsLogs detail={detail} contents={contents} table={table} />
        <DraftContentsHistory detail={detail} contents={contents} table={table} />
        { (this.state.modal == true) && <DraftDetailPreviewModal base={this.props.base} table={table} detail={detail} contents={contents} close_ev={this.toggleModal.bind(this)} change_ev={this.changeModalCaption.bind(this)} /> }

        {/* 動画直接指示モーダル */}
        { (this.state.videoModal == true) && <VideoInstructionModal base={this.props.base} table={table} detail={detail} close_ev={(flg) => this.setState({ videoModal: flg })} contents={contents} change_ev={this.changeModalCaptionMovie.bind(this)} /> }
      </div>
    );
  }
}
// -------------------------------------------------------

export default DraftContentsEdit;